module.exports = __webpack_public_path__ + "static/media/cube_destroy_test.336ff46f.jpg";